import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { X, Check, Brain, Database, MessageCircle, Bot, LineChart } from 'lucide-react';
export function CerebroDigital() {
  const comparisons = [{
    task: 'Buscar archivos',
    without: '10 min',
    with: '10 segundos'
  }, {
    task: 'Enviar plan',
    without: 'adjuntar y escribir',
    with: 'Un solo clic con link Drive'
  }, {
    task: 'No sabés quién no volvió',
    without: 'Revisar agenda manual',
    with: 'Semáforo automático en tu planilla'
  }, {
    task: 'Responder precio',
    without: 'desde cero',
    with: 'Respuesta rápida guardada'
  }, {
    task: 'Finanzas',
    without: 'papeles y memoria',
    with: 'Tablero actualizado en tiempo real'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-54">
      <FadeIn data-id="element-55">
        <div className="text-center mb-6 md:mb-12" data-id="element-56">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-blue-500/10 mb-3 md:mb-6 border border-blue-500/20 relative" data-id="element-57">
            <div className="absolute inset-0 bg-blue-500/20 blur-xl rounded-full animate-pulse" data-id="element-58"></div>
            <Brain className="text-blue-400 relative z-10 w-7 h-7 md:w-10 md:h-10" data-id="element-59" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-white mb-2 md:mb-4 px-2" data-id="element-60">
            ¿QUÉ AGREGA EL CEREBRO DIGITAL?
          </h2>
          <p className="text-sm md:text-xl text-gray-400 font-medium max-w-2xl mx-auto" data-id="element-61">
            El sistema operativo completo para automatizar tu consultorio.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-6 md:mb-12" data-id="element-62">
        <FadeIn delay={0.2} data-id="element-63">
          <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-4 md:p-8 h-full" data-id="element-64">
            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-red-900/30" data-id="element-65">
              <div className="bg-red-500/20 p-1.5 md:p-2 rounded-lg" data-id="element-66">
                <X className="text-red-500 w-5 h-5 md:w-6 md:h-6" data-id="element-67" />
              </div>
              <h3 className="text-base md:text-xl font-bold text-red-400" data-id="element-68">
                Sin Cerebro Digital
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6" data-id="element-69">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-70">
                  <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-71">
                    {item.task}
                  </span>
                  <span className="text-base md:text-lg font-mono text-gray-300" data-id="element-72">
                    {item.without}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-73">
          <div className="bg-gradient-to-br from-green-900/20 to-gray-900 border-2 border-green-500/30 rounded-2xl p-4 md:p-8 h-full relative overflow-hidden shadow-[0_0_30px_rgba(34,197,94,0.1)]" data-id="element-74">
            <div className="absolute top-0 right-0 w-64 h-64 bg-green-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-75"></div>

            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-green-500/20 relative z-10" data-id="element-76">
              <div className="bg-green-500 p-1.5 md:p-2 rounded-lg shadow-[0_0_15px_rgba(34,197,94,0.5)]" data-id="element-77">
                <Check className="text-black w-5 h-5 md:w-6 md:h-6" strokeWidth={3} data-id="element-78" />
              </div>
              <h3 className="text-base md:text-xl font-bold text-green-400" data-id="element-79">
                Con Cerebro Digital
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6 relative z-10" data-id="element-80">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-81">
                  <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-82">
                    {item.task}
                  </span>
                  <span className="text-sm md:text-lg font-mono font-bold text-white bg-green-500/10 w-fit px-2 md:px-3 py-0.5 md:py-1 rounded-md border border-green-500/20" data-id="element-83">
                    {item.with}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.4} data-id="element-84">
        <div className="flex flex-wrap justify-center gap-2 md:gap-6" data-id="element-85">
          <div className="flex items-center gap-1.5 md:gap-2 bg-gray-900 border border-gray-800 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-medium text-gray-300" data-id="element-86">
            <Database size={14} className="text-blue-400" data-id="element-87" /> Google Drive
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-gray-900 border border-gray-800 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-medium text-gray-300" data-id="element-88">
            <MessageCircle size={14} className="text-green-500" data-id="element-89" /> WhatsApp
            Business
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-gray-900 border border-gray-800 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-medium text-gray-300" data-id="element-90">
            <Bot size={14} className="text-emerald-400" data-id="element-91" /> ChatGPT
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-gray-900 border border-gray-800 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-medium text-gray-300" data-id="element-92">
            <LineChart size={14} className="text-yellow-500" data-id="element-93" /> Finanzas
          </div>
        </div>
        <p className="text-center text-sm md:text-base text-green-400 font-bold mt-3 md:mt-6" data-id="element-94">
          Plan de implementación en 48 horas incluido
        </p>
      </FadeIn>
    </section>;
}